const deviceScreenWidth = function(screenWidth) {
  let screenType = '';
  switch (true) {
    case screenWidth <= 576:
      screenType = 'xs';
      break;
    case screenWidth >= 576 && screenWidth < 768:
      screenType = 'sm';
      break;
    case screenWidth >= 768 && screenWidth < 992:
      screenType = 'md';
      break;
    case screenWidth >= 992 && screenWidth < 1200:
      screenType = 'lg';
      break;
    case screenWidth >= 1200 && screenWidth < 1400:
      screenType = 'xl';
      break;
    case screenWidth >= 1400:
      screenType = 'xxl';
      break;
    default:
      break;
  }

  return screenType;
}

const deviceByBreakPoints = function() {
  let screenSize = deviceScreenWidth(window.innerWidth);
  let device = 'desktop';
  switch (screenSize) {
    case 'xs':
    case 'sm':
      device = 'mobile';
      break;
    case 'md':
    case 'lg':
      device = 'tablet';
      break;
    default:
      device = 'desktop';
  }

  return device;
}

export const deviceChecker =  {
  deviceByBreakPoints,
  deviceScreenWidth
};